import { useLocation, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';

import { ErrorHandler as SharedErrorHandler } from '@shared/components/ErrorHandler';

import type { FileRouteTypes } from '../../routeTree.gen';
import {
  RocketErrorKey,
  getRocketErrorRedirectPath,
  mapAxiosErrorToRocketError,
} from '../../util/apiErrors';

interface Props {
  readonly children: React.ReactNode;
}

export function ErrorHandler({ children }: Props) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleNavigate = useCallback(
    (path: string) => {
      navigate({ to: path as FileRouteTypes['to'] });
    },
    [navigate]
  );

  return (
    <SharedErrorHandler
      mapAxiosErrorToRocketError={mapAxiosErrorToRocketError}
      getRedirectPath={getRocketErrorRedirectPath}
      dataFetchingErrorKey={RocketErrorKey.DataFetchingError}
      renderErrorRedirect="/n/error-message"
      resetKey={pathname}
      navigate={handleNavigate}
    >
      {children}
    </SharedErrorHandler>
  );
}
